/**
 * mi-comunidad
 * Version 2.0 de la comunidad
 *
 * The version of the OpenAPI document: 2.54.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface LoginRequest { 
    client_id: string;
    /**
     * DEPRECADO (fase 4): ya no se valida. Se mantiene declarado —y opcional— porque el body es estricto: quitarlo haría que las versiones de la app que todavía lo envían recibieran un 422.
     */
    client_secret?: string;
    username: string;
    password: string;
    deviceId?: string;
    /**
     * \'web\' | \'ios\' | \'android\'
     */
    platform?: string;
    deviceName?: string;
}

